import * as React from "react";

export const PermissionErrorMessages: React.FC<{
  message?: string;
}> = ({ message }) => {
  return (
    <div className="is-dark">
      <div className="notification is-narrow">
        <h2 className="title is-size-5">
          <span className="bg-white p-2">403: 権限エラー</span>
        </h2>
        <h3 className="subtitle">
          <span className="bg-white is-size-7-mobile">{message}</span>
        </h3>
      </div>
    </div>
  );
};
